<template>
  <div id="OrgRealNameAuthenticationConfirm">
    <el-dialog :center="true" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
      <div class="margin">
        <div>
          <h3>进行供应商实名认证可以更完整准确地将机构信息展现给采购方，从而在供应商对比中获得更大优势。</h3>
        </div>
        <div>
          <h3>供应商实名认证，认证服务费300元/年。</h3>
        </div>
        <div>&nbsp;</div>
        <div>
          <el-checkbox v-model="checked" class="eb-checkbox" @change="handleChecked">同意 <router-link target="_blank" to="/org/realname/protocal" style="color: #fb5b3b;">供应商实名认证协议</router-link></el-checkbox>
        </div>
        <div>&nbsp;</div>
        <div class="eb-button-group">
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="closeDialog">取消</el-button>
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" :disabled="isDisabled" @click="dialogConfirm">微信支付</el-button>
        </div>
        <div>
          <h5 class="explain">关于实名认证的更多咨询详情请咨询易比得官方客服</h5>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
export default {
  name: 'OrgRealNameAuthenticationConfirm',
  data() {
    return {
      dialogVisible: false,
      checked: false,
      isDisabled: true,
      departId: ''
    };
  },
  created() {
    eventBus.$on('orgRealNameAuthenticationConfirm', departId => {
      this.departId = departId;
      this.dialogVisible = true;
      this.isDisabled = true;
      this.checked = false;
    });
  },
  methods: {
    dialogConfirm: function() {
      eventBus.$emit('orgRealNameAuthenticationPay');
      this.dialogVisible = false;
    },
    handleChecked: function(val) {
      this.isDisabled = !val;
    },
    closeDialog: function() {
      this.dialogVisible = false;
      eventBus.$emit('realNameBtnLoading', false);
    },
    handleClose: function() {
      this.dialogVisible = false;
      eventBus.$emit('realNameBtnLoading', false);
    }
  }
};
</script>
<style lang="less" scoped>
#OrgRealNameAuthenticationConfirm {
  .margin {
    margin-left: 50px;
    margin-right: 50px;
  }
  .explain {
    color: #fb5b3b;
  }
  h3 {
    color: #000000;
  }
}
</style>
